import { observable, action, toJS } from "mobx";
import { isDataExist } from "Utils/dataTools";
import * as services from "../services/basic";
import { omit } from "lodash";
import { message } from "antd";

class Material {
  @observable isLoading = false;
  @observable tableData = [];
  @observable arr = []; //数据转换时过度数据
  @observable selectedRowKeys = [];
  @observable selectedRows = [];
  @observable PageInfo = { pageIndex: 1, pageSize: 10 };
  @observable formData = {};
  @observable type = ""; //查询条件
  @observable operateType = "";
  @observable modalVisible = false;
  @observable searchOptions = {};
  @observable btnLoading = false;
  @observable zynTarget = [];

  /* 测试数据的切换能力  --- Bom定义 */
  @observable tableVisible = false;
  @observable expandedRowKeys = [];


  /*搜索条件 */
  @observable searchMaterial = "";
  @observable searchMaterialType = "";

  /* 增加下级 */
  @action.bound async addChild(params) {
    this.isLoading = true;
    try {
      let res = await services.putRequest(services.requestUrl.addBom, params);
      this.isLoading = false;
      if (isDataExist(res)) {
        return res;
      }
    } catch (error) {
      console.log(error);
    }
  }
  /* 同步信息 */
  @action.bound async onSyncData(type) {
    this.btnLoading = true;
    try {
      let req = type
        ? services.requestUrl.syncBom
        : services.requestUrl.syncMaterial;
      let res = await services.getRequest(req);
      this.btnLoading = false;
      if (isDataExist(res)) {
        message.success("同步成功");
      }
    } catch (error) {
      message.success("同步失败");
      console.log(error);
    }
    this.getData(type);
  }

  //新增物料 / Bom
  @action.bound async addNew(type, params) {
    this.isLoading = true;
    const url = type
      ? services.requestUrl.saveBom
      : services.requestUrl.saveMaterial;
    try {
      let res = await services.putRequest(url, params);
      this.isLoading = false;
      if (isDataExist(res)) {
        return res;
      }
    } catch (error) {
      console.log(error);
    }
  }
  //删除物料 / Bom
  @action.bound async deleteBom(params) {
    this.isLoading = true;
    //1删除，0批量删除
    try {
      let res = await services.putRequest(
        services.requestUrl.removeBom,
        params
      );
      this.isLoading = false;
      if (isDataExist(res)) {
        return res;
      }
    } catch (error) {
      console.log(error);
    }
  }
  @action.bound async deleteMaterial(params) {
    this.isLoading = true;
    //1删除，0批量删除
    try {
      let res = await services.putRequest(
        services.requestUrl.removeMaterial,
        params
      );
      this.isLoading = false;
      if (isDataExist(res)) {
        return res;
      }
    } catch (error) {
      console.log(error);
    }
  }
  //打开/关闭模态框
  @action.bound modalChange(type, record) {
    this.operateType = type;
    if (type) {
      this.formData = record;
    } else {
      this.formData = {};
    }
    this.modalVisible = !this.modalVisible;
  }
  //获取表格数据
  @action.bound async getData(type, params) {
    this.isLoading = true;
    this.tableData = [];
    try {
      let data = {
        ...omit(this.PageInfo, "total"),
        ...this.searchOptions,
        ...params
      };
      let req = type
        ? services.requestUrl.bomNoPagedList
        : services.requestUrl.getMaterial;
      let res = await services.getRequest(req, data);
      this.isLoading = false;
      if (isDataExist(res)) {
        if (type) {
          for (let item of res.data.data.items) {
            item.children = [];
          }
          this.tableData = res.data.data.items;
          this.zynTarget = res.data.data.items;
          this.PageInfo = res.data.data.page;
        } else {
          this.tableData = res.data.data.items;
          this.zynTarget = res.data.data.items;
          this.PageInfo = res.data.data.page;
        }
      }
    } catch (error) {
      console.log(error);
    }
  }
  //请求bom下级数据
  @action.bound async getBomSec(params) {
    this.isLoading = true;
    this.tableData = [];
    try {
      let res = await services.getRequest(
        services.requestUrl.getBomSec,
        params
      );
      this.isLoading = false;
      if (isDataExist(res)) {
        res.data.data.map(item => {
          item.targetName = params.materialName;
        });
        let list = this.setChildren({
          dataS: JSON.parse(JSON.stringify(this.zynTarget)),
          resData: res.data.data,
          sourceId: params.sourceId
        });
        this.tableData = list;
        this.zynTarget = list;
      }
    } catch (error) {
      console.log(error);
    }
  }

  /* 切换BOM key 获取数据 */
  @action modifyRowClick(value) {
    let index = -1;
    index = this.expandedRowKeys.findIndex(item => item === value);
    if (index < 0) {
      this.expandedRowKeys.push(value);
    } else {
      this.expandedRowKeys.splice(index, 1);
    }
  }

  setChildren = ({ dataS, resData, sourceId }) => {
    dataS.map(item => {
      if (sourceId === item.sourceId) {
        Object.assign(item, {
          children: resData
        });
      } else {
        this.setChildren({
          dataS: item.children,
          resData,
          sourceId
        });
      }
      return item.id;
    });
    return dataS;
  };
  setMock = () => {
    return [
      {
        id: 1341,
        sourceId: 23,
        targetId: 0,
        sourceNum: 1000,
        targetNum: 1,
        createTime: "2019-11-12 17:13:50",
        modifyTime: "2019-11-12 17:13:50",
        tenantId: "1",
        materialName: "改换向器\\钩型银铜\\Φ28.2×16.8-Φ12×24\\YMQ",
        materialCode: "1CH451102",
        materialUnit: "EA",
        materialProperty: "2",
        children: [
          {
            id: 2762,
            sourceId: 1,
            targetId: 23,
            sourceNum: 1,
            targetNum: 1,
            createTime: "2019-11-13 10:20:01",
            modifyTime: "2019-11-13 10:20:01",
            tenantId: "1",
            materialName: "物料1",
            materialCode: "1234",
            materialUnit: "个",
            materialProperty: "2",
            children: [
              {
                id: 2774,
                sourceId: 234,
                targetId: 1,
                sourceNum: 1,
                targetNum: 1,
                createTime: "2019-11-19 09:26:18",
                modifyTime: "2019-11-19 09:26:18",
                tenantId: "1",
                materialName: "测试物料001",
                materialCode: "test001",
                materialUnit: "个",
                materialProperty: "2",
                children: []
              }
            ]
          },
          {
            id: 2763,
            sourceId: 2,
            targetId: 23,
            sourceNum: 1,
            targetNum: 1,
            createTime: "2019-11-13 15:42:33",
            modifyTime: "2019-11-13 15:42:33",
            tenantId: "1",
            materialName: "物料2",
            materialCode: "WL2",
            materialUnit: "个",
            materialProperty: "2",
            children: []
          },
          {
            id: 2783,
            sourceId: 2,
            targetId: 23,
            sourceNum: 123,
            targetNum: 122,
            createTime: "2019-11-21 09:31:03",
            modifyTime: "2019-11-21 09:31:03",
            tenantId: "1",
            materialName: "物料2",
            materialCode: "WL2",
            materialUnit: "个",
            materialProperty: "2",
            children: []
          },
          {
            id: 2786,
            sourceId: 1,
            targetId: 23,
            sourceNum: 1,
            targetNum: 1,
            createTime: "2019-11-21 14:10:10",
            modifyTime: "2019-11-21 14:10:10",
            tenantId: "1",
            materialName: "物料1",
            materialCode: "1234",
            materialUnit: "个",
            materialProperty: "2",
            children: []
          },
          {
            id: 2787,
            sourceId: 10,
            targetId: 23,
            sourceNum: 9,
            targetNum: 13,
            createTime: "2019-11-21 14:11:13",
            modifyTime: "2019-11-21 14:11:13",
            tenantId: "1",
            materialName: "改铝锭\\ADC12",
            materialCode: "1CA100101",
            materialUnit: "KG",
            materialProperty: "2",
            children: []
          },
          {
            id: 2788,
            sourceId: 5,
            targetId: 23,
            sourceNum: 13,
            targetNum: 13,
            createTime: "2019-11-21 14:12:31",
            modifyTime: "2019-11-21 14:12:31",
            tenantId: "1",
            materialName: "追溯测试物料",
            materialCode: "zstest00000000",
            materialUnit: "个",
            materialProperty: "2",
            children: []
          }
        ]
      },
      {
        id: 1342,
        sourceId: 24,
        targetId: 0,
        sourceNum: 4,
        targetNum: 1,
        createTime: "2019-11-12 17:13:50",
        modifyTime: "2019-11-12 17:13:50",
        tenantId: "1",
        materialName: "改高温聚脂薄膜\\0.188×20.6",
        materialCode: "1CJ113014",
        materialUnit: "KG",
        materialProperty: "2"
      },
      {
        id: 1343,
        sourceId: 26,
        targetId: 0,
        sourceNum: 3,
        targetNum: 1,
        createTime: "2019-11-12 17:13:50",
        modifyTime: "2019-11-12 17:13:50",
        tenantId: "1",
        materialName: "改白刚纸\\0.5×6",
        materialCode: "1CJ145104",
        materialUnit: "KG",
        materialProperty: "2"
      },
      {
        id: 1344,
        sourceId: 27,
        targetId: 0,
        sourceNum: 130,
        targetNum: 1,
        createTime: "2019-11-12 17:13:50",
        modifyTime: "2019-11-12 17:13:50",
        tenantId: "1",
        materialName: "改铜漆包线\\Φ0.56\\QZY-2/180",
        materialCode: "1CQ125012",
        materialUnit: "KG",
        materialProperty: "2"
      },
      {
        id: 1345,
        sourceId: 173,
        targetId: 0,
        sourceNum: 1000,
        targetNum: 1,
        createTime: "2019-11-12 17:13:50",
        modifyTime: "2019-11-12 17:13:50",
        tenantId: "1",
        materialName: "改包轴\\J1X-KZ6-210\\50WW800\\5齿",
        materialCode: "4CT130102",
        materialUnit: "EA",
        materialProperty: "2"
      },
      {
        id: 1620,
        sourceId: 23,
        targetId: 0,
        sourceNum: 1000,
        targetNum: 1,
        createTime: "2019-11-12 17:13:54",
        modifyTime: "2019-11-12 17:13:54",
        tenantId: "1",
        materialName: "改换向器\\钩型银铜\\Φ28.2×16.8-Φ12×24\\YMQ",
        materialCode: "1CH451102",
        materialUnit: "EA",
        materialProperty: "2"
      },
      {
        id: 1621,
        sourceId: 24,
        targetId: 0,
        sourceNum: 4,
        targetNum: 1,
        createTime: "2019-11-12 17:13:54",
        modifyTime: "2019-11-12 17:13:54",
        tenantId: "1",
        materialName: "改高温聚脂薄膜\\0.188×20.6",
        materialCode: "1CJ113014",
        materialUnit: "KG",
        materialProperty: "2"
      },
      {
        id: 1622,
        sourceId: 26,
        targetId: 0,
        sourceNum: 3,
        targetNum: 1,
        createTime: "2019-11-12 17:13:54",
        modifyTime: "2019-11-12 17:13:54",
        tenantId: "1",
        materialName: "改白刚纸\\0.5×6",
        materialCode: "1CJ145104",
        materialUnit: "KG",
        materialProperty: "2"
      },
      {
        id: 1623,
        sourceId: 27,
        targetId: 0,
        sourceNum: 130,
        targetNum: 1,
        createTime: "2019-11-12 17:13:54",
        modifyTime: "2019-11-12 17:13:54",
        tenantId: "1",
        materialName: "改铜漆包线\\Φ0.56\\QZY-2/180",
        materialCode: "1CQ125012",
        materialUnit: "KG",
        materialProperty: "2"
      },
      {
        id: 1624,
        sourceId: 173,
        targetId: 0,
        sourceNum: 1000,
        targetNum: 1,
        createTime: "2019-11-12 17:13:54",
        modifyTime: "2019-11-12 17:13:54",
        tenantId: "1",
        materialName: "改包轴\\J1X-KZ6-210\\50WW800\\5齿",
        materialCode: "4CT130102",
        materialUnit: "EA",
        materialProperty: "2"
      }
    ];
  };

  @observable materialList = [];
  // 获取物料
  @action async getAllMaterial(params) {
    try {
      let res = await services.getRequest(
        services.requestUrl.getBomList,
        params
      );
      if (isDataExist(res)) {
        this.materialList = res.data.data;
      }
    } catch (error) {
      console.log(error);
    }
  }
  //数据类型转换(平级数据装换成树结构)
  @action.bound transTreeData = items => {
    if (items.length > 0) {
      let curPid = 0; //pid=0，为最上层节点 ，即无父节点
      let parent = this.findChild(curPid); //数组
      return parent;
    } else {
      return [];
    }
  };
  //找子节点
  @action.bound findChild = curPid => {
    let _arr = [];
    let items = this.arr;
    let length = items.length;
    for (let i = 0; i < length; i++) {
      if (items[i].parentId == curPid) {
        let _obj = items[i];
        _obj.children = this.findChild(_obj.cateId);
        _arr.push(_obj);
      }
    }
    return _arr;
  };

  @action clearAll() {
    this.isLoading = false;
    this.tableData = [];
    this.arr = []; //数据转换时过度数据
    this.selectedRows = []; //表格被选中的行
    this.selectedRowKeys = [];
    this.PageInfo = { pageIndex: 1, pageSize: 10 };
    this.formData = {};
    this.type = ""; //查询条件
    this.modalVisible = false;
    this.searchOptions = {};
    this.bomsec = [];

    this.searchMaterial = "";
    this.searchMaterialType = "";
  }
}

let MaterialStore = new Material();
export default MaterialStore;
